import { createNetworkApi } from '@lib/util/networkRequest';

import apiInstance from '../instances/drupal';

function fileRequest (fileType, fileName, fileData, token, userId) {
  return {
    method: 'post',
    url: '/entity/file?_format=hal_json',
    headers: {
      'Accept': 'application/hal+json',
      'Content-Type': 'application/hal+json',
      'X-CSRF-Token': token
    },
    data: {
      _links: {
        type: {
          href: `${process.env.NEXT_PUBLIC_DRUPAL_API_URL}/rest/type/file/${fileType}`
        }
      },
      filename: [
        { value: fileName }
      ],
      type: [
        { target_id: fileType }
      ],
      uid: [
        { target_id: userId } 
      ],
      uri: [
        { value: `public://field_name/${fileName}`}
      ],
      data: [
        { value: fileData }
      ]
    }
  };
}

export default createNetworkApi (apiInstance, {
  uploadImage: (fileName, fileData, token, userId) => fileRequest('image', fileName, fileData, token, userId),
  uploadVideo: (fileName, fileData, token, userId) => fileRequest('video', fileName, fileData, token, userId),
  uploadDocument: (fileName, fileData, token, userId) => fileRequest('document', fileName, fileData, token, userId)
});
